import React, { useState } from 'react'
import { Button } from 'react-bootstrap'

import AttachProductModal from './attach_product_modal'


const initialState = {
  attachProductModalOpen: false
}

const AttatchProduct = ({ userData, client }) => {

  const [state, setState] = useState(initialState)

  const onClickAttachProduct = () => {
    setState((prevState) => ({
      ...prevState,
      attachProductModalOpen: !prevState.attachProductModalOpen
    }))
  }

  const onAttachProductModalClose = () => {
    setState(initialState)
  }

  return (
    <>
      <Button
        className='attach-product-btn'
        variant='outline-primary'
        onClick={onClickAttachProduct}
      >
        Attatch Plan
      </Button>
      <AttachProductModal
        attachProductModalOpen={state.attachProductModalOpen}
        onAttachProductModalClose={onAttachProductModalClose}
        userData={userData}
        client={client}
      />
    </>
  )
}

export default AttatchProduct